<script setup lang="ts">
defineProps<{
  id: string;
  label: string;
  modelValue: string | null | undefined;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();
</script>

<template>
  <div class="field">
    <label class="label">{{ label }}</label>
    <div class="control">
      <input
        class="input date"
        type="date"
        :id="id"
        :value="modelValue"
        @input="
          emit('update:modelValue', ($event.target as HTMLInputElement).value)
        "
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<style scoped>
.date {
  width: auto;
}
</style>
